import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import Loader from '../../components/ui/Loader/Loader';
import Ax from '../../components/hoc/Ax';
import Status from '../../components/ui/Status';
import DateService from '../../services/DateService';
import HttpAPICall from '../../services/HttpAPICall';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TapHelper from '../../services/TapHelper';
import TicketSummary from './TicketSummary';
import CurrencyFormatter from '../../services/CurrencyFormatter';




const ProjectData = forwardRef((props, ref) => {

    const urlType       =   (type) => {
        switch(type) {
            case "Expense" :
                return "expense_list"
            case "Item Demands" :
                return "item_demand_list"
            case "Allocation" :
                return "allocation_list"
            case "Consumption" :
                return "consumption_list"
            case "Warehouse Indent" :
                return "warehouse_indent_list"
            case "Purchase Requisition" :
                return "requisition_list"
            case "Purchase Order" :
                return "purchase_order_list"     
            default :
                return ""
        }
    } 
    const formatSeconds = (seconds) => {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        return `${hrs}h ${mins}m`;
    };


    const linkingDetailJsx = () => {
        let projectDetail = props.projectDetails;
        let linkingData = projectDetail.linking_data;
        
        return (
            <Ax>
                <div>
                    <div className="tab_content_wrapper mb-2"><span className="content_heading">Linking Details</span> </div>
                    <table className="table mt-2 table-hover table-bordered" >
                        <tbody>
                            <tr>
                                <th style={{ width: "25%" }}>Type</th>
                                <th style={{ width: "25%" }}>No. Of Vouchers</th>
                                <th style={{ width: "25%" }}>Quantity</th>
                                <th style={{ width: "25%" }}>Total Amount</th>
                            </tr>
                            {linkingData.map((row) => {
                                let url = urlType(row.type);
                                return (<tr key={url}>
                                    <th>{row.type}</th>
                                    <td>
                                        <Link to={{ pathname: `/${url}?search_project_id=${projectDetail.id}` }} target="_blank"
                                    >{row.vouchers}</Link>
                                    </td>
                                    <td>{row.qty}</td>
                                    <td>{row.amount}</td>
                                </tr>
                                )
                            }
                            )}
                        </tbody>
                    </table>
                </div>
            </Ax>
        );
    };
    const calculateTotalConsumed = () => {
        let projectDetail = props.projectDetails;
        if (!projectDetail?.linking_data) return 0;

        let total = 0;
        projectDetail.linking_data.forEach(item => {
            if (item.type === "Expense" || item.type === "Consumption") {
                const amount = item.amount ? parseFloat(item.amount) : 0;
                total += amount;
            }
        });
        return total;
    };
    const projectDetailJsx = () => {
        let projectDetail = props.projectDetails;
        
        let totalConsumed = calculateTotalConsumed();
         let budgetAmount = projectDetail?.budget ? parseFloat(projectDetail.budget) : 0;
        let finalAmount = budgetAmount - totalConsumed;
        let percentageConsumedBudget = '';
        if (budgetAmount > 0 && totalConsumed > 0) {
            percentageConsumedBudget = ((totalConsumed / budgetAmount) * 100).toFixed(2) + '%';
        } else if (budgetAmount > 0 && totalConsumed === 0) {
            percentageConsumedBudget = '0%';
        } else {
            percentageConsumedBudget = '-';
        }
        
        return<>
          {props.project_detail_loading ? <Loader /> : <Ax>
            <table className="table mt-2 table-hover table-bordered ">
                <tbody>
                    <tr>
                        <td style={{ width: "25%" }}>Project Name</td>
                        <th colSpan={3} style={{ width: "75%" }}>{projectDetail ? projectDetail.name : ''}</th>
                    </tr>
                    <tr>
                        <td style={{ width: "25%" }}>Category</td>
                        <th colSpan={3} style={{ width: "75%" }}>{projectDetail ? projectDetail?.category?.name : ''}</th>
                    </tr>
                    <tr>
                        <td>Project ID</td>
                        <th colSpan={3} >{projectDetail ? projectDetail.transaction_id : "-"}</th>
                    </tr>
                    <tr>
                        <td >Total Ticket</td>
                        <th colSpan={3} >{projectDetail ? projectDetail.count_tickets : "-"}</th>
                    </tr>
                    <tr>
                        <td >Site</td>
                        <th colSpan={3} >{projectDetail && projectDetail.site ? projectDetail.site.site_name : "-"}</th>
                    </tr>
                    <tr>
                        <td >Status</td>
                        <th colSpan={3} >{projectDetail && projectDetail.status && <Status color={projectDetail.status.color_code}> {projectDetail.status.status}
                        </Status>}</th>
                    </tr>
                    <tr>
                        <td >Reason For Delay</td>
                        <th colSpan={3} >{projectDetail ? projectDetail.reason_for_delay : "-"}</th>
                    </tr>
                    <tr>
                        <td >Notes</td><th colSpan={3} >{projectDetail ? projectDetail.notes : "-"}</th>
                    </tr>

                    <tr>
                        <td>Total Estimate Days</td><th colSpan={3} >{projectDetail ? projectDetail.total_estimate_days : ""}</th>
                    </tr>
                    <tr>
                        <td>Critical Path Days</td><th colSpan={3} >{projectDetail ? projectDetail.critical_path_days : ""}</th>
                    </tr>
                    <tr>
                        <td >Project Start Date</td>
                        <th colSpan={3}>
                            {projectDetail && projectDetail.starting_date
                                ? DateService.dateTimeFormat(projectDetail.starting_date, "DD-MMM-YYYY")
                                : "-"}
                        </th>
                    </tr>
                        <tr>
                            <td >No. of Worklog</td>
                            <th>
                                {projectDetail && projectDetail?.emp_work_log
                                    ? projectDetail?.emp_work_log?.total_work_log
                                    : "-"}
                            </th>
                            <td >Total Duration</td>
                            <th>
                                {projectDetail && projectDetail?.emp_work_log?.total_duration ? formatSeconds(projectDetail?.emp_work_log?.total_duration) : '-'}
                            </th>
                        </tr>
                    {projectDetail && projectDetail.status && projectDetail.status.key == 26
                        ? <tr>
                            <td >Project Completion Date</td>
                            <th >
                                {projectDetail && projectDetail.completion_date
                                    ? DateService.dateTimeFormat(projectDetail.completion_date, "DD-MMM-YYYY")
                                    : "-"}
                            </th>
                            <td >Project Completion Days</td>
                            <th style={{ width: "25%" }}>
                                {projectDetail && projectDetail.completion_date ? DateService.differenceInDays(projectDetail.starting_date, projectDetail.completion_date) : '-'} Days
                            </th>
                        </tr>
                        : <tr>
                            <td >Current Estimated Completion Date</td>
                            <th>
                                {projectDetail && projectDetail.estimated_completion_date
                                    ? DateService.dateTimeFormat(projectDetail.estimated_completion_date, "DD-MMM-YYYY")
                                    : "-"}
                            </th>
                            <td >Current Estimated Completion Days</td>
                            <th>
                                {projectDetail && projectDetail.starting_date && projectDetail.estimated_completion_date
                                    ? <>{DateService.differenceInDays(projectDetail.starting_date, projectDetail.estimated_completion_date)} Days</>
                                    : ''}
                            </th>
                        </tr>}
                    <tr>
                        <td style={{ width: "25%" }}>Original Estimated Completion Date</td>
                        <th style={{ width: "25%" }}>
                            {projectDetail && projectDetail.original_estimate_date
                                ? DateService.dateTimeFormat(projectDetail.original_estimate_date, "DD-MMM-YYYY") : "-"}
                        </th>
                        <td style={{ width: "25%" }}>Original Estimated Completion Days</td>
                        <th style={{ width: "25%" }}>
                            {projectDetail && projectDetail.estimated_completion_date
                                ? <>{projectDetail.original_estimate_days} Days</>
                                : ''}
                        </th>
                    </tr>
                </tbody>
            </table>

            <div className="tab_content_wrapper mb-2"><span className="content_heading">Budget</span> </div>
            <table className="table table-bordered bg-white table-hover">
                <tbody>
                    <tr>
                        <td style={{ width: "25%" }}>Total Budget Amount</td>
                        <th style={{ width: "25%" }}>
                            {projectDetail?.budget ? <CurrencyFormatter currencyCode={props.default_currency} amount={projectDetail?.budget}/> : "-"}
                        </th>
                        <td style={{ width: "25%" }}>Total Budget Consumed</td>
                        <th style={{ width: "25%" }}>
                            {totalConsumed > 0 ? <CurrencyFormatter currencyCode={props.default_currency} amount={totalConsumed}/> : "-"}
                        </th>
                    </tr>
                    <tr>
                            <td style={{ width: "25%" }}>Remaining Amount</td>
                            <th style={{ width: "25%" }}>
                                {finalAmount > 0 ? <CurrencyFormatter currencyCode={props.default_currency} amount={finalAmount} /> : "-"}
                            </th>
                            <td style={{ width: "25%" }}>Consumed Budget Percentage</td>
                            <th style={{ width: "25%" }}>{percentageConsumedBudget}</th>
                        </tr>
                    </tbody>
            </table>


            {projectDetail?.additional_attr && projectDetail.additional_attr.length > 0 &&
                <>
                    <div className="tab_content_wrapper mb-2"><span className="content_heading">Additional Attributes</span> </div>
                    <table className="table mt-2 table-hover table-bordered">
                        <tbody>
                            {projectDetail.additional_attr.map((attr) => {
                                let displayValue = attr?.value ? attr.value : "-";
                                if (attr.type === 'datetime') {
                                    displayValue = DateService.dateFormat(attr.value, 'DD-MMM-YYYY HH:mm:ss');
                                } else if (attr.type === 'date') {
                                    displayValue = DateService.dateFormat(attr.value, 'DD-MMM-YYYY');
                                }
                                return (<tr key={attr.key}>
                                    <td scope="col" style={{ width: "25%" }} className='text-capitalize'>{attr.name ? attr.name : "-"}</td>
                                    <th colSpan={3} style={{ width: "75%" }}>{displayValue}</th>
                                </tr>)
                            })}
                        </tbody>
                    </table>

                </>
            }
            {projectDetail &&
                projectDetail.linking_data &&
                projectDetail.linking_data.length > 0 &&
                linkingDetailJsx()
            }
            <div>
                <TicketSummary projectId={projectDetail?.id} />
            </div>

        </Ax>}
        </>
      

    };

    return <>
        <div style={{ overflowY: "auto", height: "calc(100vh - 150px)", backgroundColor: "white" }} className='mx-2'>
            {projectDetailJsx()}
        </div>
    </>
});


export default ProjectData;